module.exports = __webpack_public_path__ + "img/header_language_more.d3cb0d3b.svg";